import hexToRgba from "hex-rgba";
import commonTheme from "./common-theme";

const theme = {
  name: "barkio-light",
  fonts: commonTheme.fonts,
  breakpoints: commonTheme.breakpoints,
  isDarkMode: false,
  colors: {
    ...commonTheme.colors,
    primary: "#58a509",
    primaryLight: hexToRgba("#58a509", 12),
    primaryLight2: hexToRgba("#58a509", 24),
    primaryLighter: "#6eb918",
    primaryDarker: "#409100",
    primaryBackground: "#58a509",

    secondary: "#825f5f",
    secondaryLight: hexToRgba("#825f5f", 12),
    secondaryLight2: hexToRgba("#825f5f", 24),
    secondaryLighter: "#937877",
    secondaryDarker: "#775656",

    get highEmphasis() {
      return this.black;
    },
    get mediumEmphasis() {
      return this.black54;
    },
    get lowEmphasis() {
      return this.black38;
    },
    get outline() {
      return this.black20;
    },
    get outlineHover() {
      return this.black38;
    },
    get surface() {
      return this.white;
    },
    get surfaceElevated1() {
      return this.white;
    },
    get surfaceElevated2() {
      return this.white;
    },
    get surfaceElevated3() {
      return this.white;
    },
    get hover() {
      return this.black4;
    },
    get iconBackground() {
      return this.black8;
    },
    get overlay() {
      return this.black30;
    },

    warningBase: "#ff4f41",
    warningLight: hexToRgba("#ff4f41", 12),
    warningLight2: hexToRgba("#ff4f41", 30),
    warningLighter: "#ff6e64",
    warningDarker: "#ef453f",

    tint1: "#fa4863",

    tint2: "#fab500",
    tint2Light: hexToRgba("#fab500", 12),

    tint3: "#4285f4",
    tint3Light: hexToRgba("#4285f4", 12),

    tint4: "#9b1ff4",
    tint4Light: hexToRgba("#9b1ff4", 12),

    "command-tint1": "#ff4f41",

    "command-tint2": "#f58900",
    "command-tint2Light": hexToRgba("#f58900", 16),

    "command-tint3": "#92ad00",

    "command-tint4": "#00aa9a",
    "command-tint4Light": hexToRgba("#00aa9a", 12),

    "command-tint5": "#4285f4",

    "command-tint6": "#4545e9",

    "command-tint7": "#9b1ff4",

    "command-tint8": "#fa48ad",
    "command-tint8Light": hexToRgba("#fa48ad", 12),

    tintRed: "#FF4F41",
    tintOrange: "#F58900",
    tintYellow: "#FAB500",
    tintOlive: "#92AD00",
    tintGreen: "#58A509",
    tintTurquoise: "#2AA598",
    tintBlue: "#4D8DF7",
    tintBlueLight: hexToRgba("#4D8DF7", 12),
    tintIndigo: "#4F5CFF",
    tintPurple: "#8F6DF5",
    tintPink: "#FA48AD",
    tintBrown: "#825F5F"
  }
};

export default theme;
